var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Predelovalec")]),_c('h4',[_vm._v(_vm._s(_vm.predelovalec.naziv))]),_c('p',[_vm._v(" "+_vm._s(_vm.predelovalec.naslov)+", "+_vm._s(_vm.predelovalec.postnastevilka)+" "+_vm._s(_vm.predelovalec.posta)),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }